import { getConfig } from './config'

export default ({ store, $uiEvents, $config, $sitewideData, $integrationsManager, $push, app }) => {
    const config = getConfig($config.platform.mode)

    const affirmConfig = {
        public_api_key: $sitewideData.config.affirmApiKey,
        script: config.scriptSrc,
    }

    const { load } = $integrationsManager.loaders.onDemandCallbackLoader(() => {
        /* eslint-disable */
        // prettier-ignore
        (function(l,g,m,e,a,f,b){var d,c=l[m]||{},h=document.createElement(f),n=document.getElementsByTagName(f)[0],k=function(a,b,c){return function(){a[b]._.push([c,arguments])}};c[e]=k(c,e,"set");d=c[e];c[a]={};c[a]._=[];d._=[];c[a][b]=k(c,a,b);a=0;for(b="set add save post open empty reset on off trigger ready setProduct".split(" ");a<b.length;a++)d[b[a]]=k(c,e,b[a]);a=0;for(b=["get","token","url","items"];a<b.length;a++)d[b[a]]=function(){};h.async=!0;h.src=g[f];n.parentNode.insertBefore(h,n);delete g[f];d(g);l[m]=c})(window,affirmConfig,"affirm","checkout","ui","script","ready");
        /* eslint-enable */
    })

    async function open(successCallbackRoute, cancelCallbackRoute) {
        load()

        try {
            const affirmObjectResponse = await store.dispatch('checkout/getAffirmObject', {
                userConfirmationUrl: successCallbackRoute,
                userCancelUrl: cancelCallbackRoute || successCallbackRoute,
            })

            $uiEvents.$emit('affirmPaymentModalViewed') // Launch pay with Affirm
            $uiEvents.$emit('affirmPaymentInfoEntered')

            window.affirm.checkout(affirmObjectResponse)

            window.affirm.checkout.open()
        } catch (error) {
            store.dispatch('addGeneralError', error)
        }
    }

    async function placeOrder(checkoutToken) {
        try {
            const orderId = await store.dispatch('checkout/placeAffirmOrder', checkoutToken)

            $uiEvents.$emit('affirmPaymentModalCompleted')

            await $push.to({
                name: 'receipt',
                query: {
                    orderId,
                },
            })
        } catch (error) {
            app.$log.warning('placeAffirmOrder err', { error })
            throw error
        }
    }

    return {
        load,
        open,
        placeOrder,
    }
}
